import { render, staticRenderFns } from "./footer-admin.vue?vue&type=template&id=38357500&"
import script from "./footer-admin.vue?vue&type=script&lang=js&"
export * from "./footer-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports